import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReportsRoutingModule } from './reports-routing.module';
import { ReportsComponent } from './pages/reports/reports.component';
import { SharedModule } from '@app-shared/shared.module';
import { ReportPageFilterComponent } from '@app-reports/components/report-page-filter/report-page-filter.component';
import { ReportDriverListComponent } from '@app-reports/components/report-driver-list/report-driver-list.component';
import { ReportIncidentTrendComponent } from '@app-reports/components/report-incident-trend/report-incident-trend.component';
import { ReportIncidentSummaryComponent } from '@app-reports/components/report-incident-summary/report-incident-summary.component';
import { SafetyStatsComponent } from '@app-reports/components/safety-stats/safety-stats.component';
import { FleetSafetyReportComponent } from './pages/fleet-safety-report/fleet-safety-report.component';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { StoreModule } from '@ngrx/store';
import { reducers } from './reducers';
import { CoachingSessionReportComponent } from './pages/coaching-session-report/coaching-session-report.component';
import { CoachingReportsStatsComponent } from './components/coaching-reports-stats/coaching-reports-stats.component';
import { CoachingSessionAccoladesComponent } from './components/coaching-session-accolades/coaching-session-accolades.component';
import { BehaviourSummaryComponent } from './components/behaviour-summary/behaviour-summary.component';
import { ExportHistoryComponent } from './components/export-history/export-history.component';
import { CoachingEffectivenessDriverComponent } from './pages/coaching-effectiveness-driver/coaching-effectiveness-driver.component';
import { CoachingEffectivenessEventWiseComponent } from './components/coaching-effectiveness-event-wise/coaching-effectiveness-event-wise.component';
import { CoachingTimelineComponent } from './components/coaching-timeline/coaching-timeline.component';
import { CoachingEffectivenessDriverStatsComponent } from './components/coaching-effectiveness-driver-stats/coaching-effectiveness-driver-stats.component';
import { ScheduledReportComponent } from './pages/scheduled-report/scheduled-report.component';
import { ListScheduledReportsComponent } from './components/list-scheduled-reports/list-scheduled-reports.component';
import { CreateScheduleComponent } from './components/create-schedule/create-schedule.component';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    ReportsComponent,
    FleetSafetyReportComponent,
    ReportPageFilterComponent,
    ReportDriverListComponent,
    ReportIncidentTrendComponent,
    ReportIncidentSummaryComponent,
    SafetyStatsComponent,
    CoachingSessionReportComponent,
    CoachingReportsStatsComponent,
    CoachingSessionAccoladesComponent,
    BehaviourSummaryComponent,
    ExportHistoryComponent,
    CoachingEffectivenessDriverComponent,
    CoachingEffectivenessEventWiseComponent,
    CoachingTimelineComponent,
    CoachingEffectivenessDriverStatsComponent,
    ScheduledReportComponent,
    ListScheduledReportsComponent,
    CreateScheduleComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReportsRoutingModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    StoreModule.forFeature('Reports', reducers),
  ],
})
export class ReportsModule {}
